import React from "react";
import "./stylesheets/Work.css";
import WorkCard from "./WorkCard";
import outnet from "../assets/outnet.webp";
import maxfashion from "../assets/maxfashion.webp";
import orbitz from "../assets/orbitz.webp";

const Work = () => {
  const projects = [
    {
      image: maxfashion,
      title: "Max Fashion Clone",
      description:
        "A well-known web app clone for buying clothes and accessories for men, women & children with backend integrated.",
      tech: "React | Redux | Node JS | Express | MongoDB | HTML | CSS | Chakra UI",
      vid: "https://www.linkedin.com/posts/jyoti-kamal-singh_project-activity-7010879003037175808-74-8?utm_source=share&utm_medium=member_desktop",
      netlify: "https://max-fashion-jk.netlify.app",
      github: "https://github.com/jksingh1504/max-fashion-clone",
    },
    {
      image: outnet,
      title: "The Outnet Clone",
      description:
        "A well-known web app clone for buying clothes and accessories for men and women with signup and login functionality.",
      tech: "HTML| CSS | JavaScript | Local storage",
      vid: "https://drive.google.com/file/d/1NTgZUlJeHaZoBdHJlMwAk6t5LJVKUrP6/view?usp=sharing",
      netlify: "https://theoutne-e7f2b5.netlify.app",
      github: "https://github.com/9Prajjwal/outnetclone",
    },
    {
      image: orbitz,
      title: "The Orbitz Clone",
      description:
        "A well-known web app clone for travel fare aggregation & metasearch with user authentication.",
      tech: "React | Redux | Chakra UI | JavaScript| CSS | JSON server | Heroku API",
      vid: "https://drive.google.com/file/d/1u4KFT9SQaZvL7kxr64HE6JaWTSNOt6cC/view?usp=sharing",
      netlify: "https://orbitz-clone-jyotikamal.netlify.app",
      github: "https://github.com/jksingh1504/changeable-cracker-8993",
    },
  ];

  return (
    <div id="work">
      <h1>
        MY Creative <span style={{ color: "#dc143c" }}>Portfolio </span>Section{" "}
      </h1>
      <div>
        {projects.map((ele, indx) => {
          return <WorkCard key={indx} ele={ele} />;
        })}
      </div>
    </div>
  );
};

export default Work;
